import "lenis/dist/lenis.css";
import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { AuthProvider } from "@/context/AuthContext";
import { Toaster } from "@/components/ui/sonner";
import Layout from "@/components/Layout";
import Home from "@/pages/Home";
import ProgramPage from "@/pages/ProgramPage";
import MediaPress from "@/pages/MediaPress";
import SocialGallery from "@/pages/SocialGallery";
import Login from "@/admin/Login";
import AdminLayout from "@/admin/AdminLayout";
import PagesList from "@/admin/PagesList";
import PageEditor from "@/admin/PageEditor";
import MediaPage from "@/admin/MediaPage";
import MenuBuilder from "@/admin/MenuBuilder";
import HomepageEditor from "@/admin/HomepageEditor";
import GalleryManager from "@/admin/GalleryManager";
import SocialGalleryManager from "@/admin/SocialGalleryManager";

function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Toaster position="top-center" richColors />
        <Routes>
          <Route path="/admin/login" element={<Login />} />
          <Route path="/admin" element={<AdminLayout />}>
            <Route index element={<Navigate to="/admin/pages" replace />} />
            <Route path="homepage" element={<HomepageEditor />} />
            <Route path="pages" element={<PagesList />} />
            <Route path="pages/new" element={<PageEditor />} />
            <Route path="pages/:slug" element={<PageEditor />} />
            <Route path="media" element={<MediaPage />} />
            <Route path="gallery" element={<GalleryManager />} />
            <Route path="videos" element={<SocialGalleryManager />} />
            <Route path="menu" element={<MenuBuilder />} />
          </Route>
          <Route element={<Layout />}>
            <Route path="/" element={<Home />} />
            <Route path="/programs/:slug" element={<ProgramPage />} />
            <Route path="/media-press" element={<MediaPress />} />
            <Route path="/social-gallery" element={<SocialGallery />} />
          </Route>
        </Routes>
      </BrowserRouter>
    </AuthProvider>
  );
}

export default App;
